// reducers.js

import { combineReducers } from 'redux';

const initialBlastOffState = {
  blastOffRules: null,
  loading: false,
  error: null,
};

const blastOffReducer = (state = initialBlastOffState, action) => {
  switch (action.type) {
    case 'FETCH_BLASTOFF_RULE_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_BLASTOFF_RULE_SUCCESS':
      return { ...state, blastOffRules: action.payload, loading: false, error: null };
    case 'FETCH_BLASTOFF_RULE_FAILURE':
      return { ...state, blastOffRules: null, loading: false, error: action.payload };
    default:
      return state;
  }
};

const initialHealthState = {
  healthInfo: null,
  loading: false,
  error: null,
};

const healthReducer = (state = initialHealthState, action) => {
  switch (action.type) {
    case 'FETCH_HEALTH_INFO_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_HEALTH_INFO_SUCCESS':
      return { ...state, healthInfo: action.payload, loading: false, error: null };
    case 'FETCH_HEALTH_INFO_FAILURE':
      return { ...state, healthInfo: null, loading: false, error: action.payload };
    default:
      return state;
  }
};
const initialGeneInfoState = {
  geneInfo: null,
  loading: false,
  error: null,
};

const geneInfoReducer = (state = initialGeneInfoState, action) => {
  switch (action.type) {
    case 'FETCH_GENE_INFO_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_GENE_INFO_SUCCESS':
      return { ...state, geneInfo: action.payload, loading: false, error: null };
    case 'FETCH_GENE_INFO_FAILURE':
      return { ...state, geneInfo: null, loading: false, error: action.payload };
    default:
      return state;
  }
};

const initialReferenceInfoState = {
  referenceInfo: null,
  loading: false,
  error: null
}
const referenceInfoReducer = (state = initialReferenceInfoState, action) => {
  switch (action.type) {
    case 'FETCH_BLASTOFF_REFERENCE_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_BLASTOFF_REFERENCE_SUCCESS':
      return { ...state, referenceInfo: action.payload, loading: false, error: null };
    case 'FETCH_BLASTOFF_REFERENCE_FAILURE':
      return { ...state, referenceInfo: null, loading: false, error: action.payload };
    default:
      return state;
  }
};
const initialDietRecommendationState = {
  dietRecommendationInfo: null,
  loading: false,
  error: null
}
const dietRecommendationReducer = (state = initialDietRecommendationState, action) => {
  switch (action.type) {
    case 'FETCH_BLASTOFF_DIET_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_BLASTOFF_DIET_SUCCESS':
      return { ...state, dietRecommendationInfo: action.payload, loading: false, error: null };
    case 'FETCH_BLASTOFF_DIET_FAILURE':
      return { ...state, dietRecommendationInfo: null, loading: false, error: action.payload };
    default:
      return state;
  }
};

const initialSurveyState = {
  surveyResult: null,
  loading: false,
  error: null,
  
};

const surveyReducer = (state = initialSurveyState, action) => {
  switch (action.type) {
    case 'POST_PET_SURVEY_REQUEST':
    case 'GET_PET_SURVEY_REQUEST':
      return { ...state, loading: true, error: null };

    case 'POST_PET_SURVEY_SUCCESS':
    case 'GET_PET_SURVEY_SUCCESS':
      return { ...state, surveyResult: action.payload, loading: false, error: null };

    case 'POST_PET_SURVEY_FAILURE':
    case 'GET_PET_SURVEY_FAILURE':
      return { ...state, surveyResult: null, loading: false, error: action.payload };

    default:
      return state;
  }
};

const initialImageState = {
  loading: false,
  success: false,
  error: null,
  image: null, // Add this line
};

export const surveyImageReducer = (state = initialImageState, action) => {
  switch (action.type) {
    case 'UPDATE_SURVEY_IMAGE_REQUEST':
      return { ...state, loading: true, success: false, error: null };
    case 'UPDATE_SURVEY_IMAGE_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        image: action.payload, // Store the updated image
      };
    case 'UPDATE_SURVEY_IMAGE_FAILURE':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};



const rootReducer = combineReducers({
  health: healthReducer,
  blastOff: blastOffReducer,
  gene: geneInfoReducer,
  reference: referenceInfoReducer,
  dietRecommendation: dietRecommendationReducer,
  survey: surveyReducer,
  surveyImage : surveyImageReducer
  // Add more reducers here as needed
});

export default rootReducer;
